import React from 'react';
import { connect } from 'react-redux';
import {Link} from 'react-router';
import {ListGroupTypeReception} from 'modules/reception';
import { ThongTinUyQuyen } from 'modules/reception';
import {ThongTinCaNhan} from 'modules/reception';
import { CheckBox, DropDown, Input } from 'components/tt-forms/common';
import { ShowIf } from 'components/utils';
import { DuLieuHeThong } from 'api';

import {validatable} from 'components/utils';

class ThongTinNguoiDungDon extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      flagUyQuyen: false,
      loaiNguoiDungDonId: 'CA_NHAN',
      tenCoQuan: '',
      diaChiCoQuan: '',
      soDienThoai: '',
      soNguoi: '',
      soNguoiDaiDien: '',
      phanLoaiNguoiDungDonList: this.props.phanLoaiNguoiDungDonList
    }
  }

  onChangeCheckBox(name, e) {
    this.state[name] = !this.state[name];
    this.setState({...this.state});
    this.props.onChange(this.state);
  }

  componentDidMount() {
    if(this.props.phanLoaiNguoiDungDonList.length == 0) {
      DuLieuHeThong.actions.getLoaiDungDon.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'phanLoaiNguoiDungDonList',
            data: res.data || []
          }]
        })
      })
    }
  }

  onChange(name, e) {
    this.state[name] = e.target.value;
    if (name == 'loaiNguoiDungDonId' && e.target.value == 'CO_QUAN_TO_CHUC') {
      this.props.dispatch({
        type: 'INIT_NGUOI_DAI_DIEN_CO_QUAN'
      });
    }
    this.setState({...this.state});
    this.props.onChange(this.state);
  }

  addNguoiDaiDien() {
    this.props.dispatch({
      type: 'THEM_NGUOI_DUNG_DON'
    });

    this.props.onChange(this.state);
  }

  onChangeDoanDongNguoi(data) {
    let newState = {
      ...this.state,
      doanDongNguoi: data
    }
    this.props.onChange(newState);
  }

  onChangeThongTinUyQuyen(data, isInit) {
    let newState = {
      ...this.state,
      uyQuyen: data
    }
    if (isInit) {
      this.props.onInit(newState);
    } else {
      this.props.onChange(newState);
    }
  }

  getThongTinCaNhan(index, thongTinCaNhan) {
    this.props.dispatch({
      type: 'CAP_NHAT_THONG_TIN_CA_NHAN',
      data: thongTinCaNhan,
      index
    });
    this.props.onChange(this.state);
  }

  handleRemove(data) {
    this.props.dispatch({
      type: 'XOA_NGUOI_DUNG_DON',
      data
    });
    this.props.onRemove('CONG_DAN', data);
    this.props.onChange(this.state);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.editData != this.props.editData) {
      let data = nextProps.editData;
      this.state.flagUyQuyen = data.coUyQuyen;
      this.state.loaiNguoiDungDonId = data.loaiNguoiDungDon;
      this.state.soNguoi = data.soNguoi;
      this.state.soNguoiDaiDien = data.listNguoiDungDon.length;
      if (data.loaiNguoiDungDon == 'CO_QUAN_TO_CHUC') {
        this.state.tenCoQuan = data.listNguoiDungDon[0].tenCoQuan;
        this.state.diaChiCoQuan = data.listNguoiDungDon[0].diaChiCoQuan;
        this.state.soDienThoai = data.listNguoiDungDon[0].soDienThoaiCoQuan;
      }
      this.setState({...this.state});
      this.props.onInit(this.state);
    }
    if (nextProps.phanLoaiNguoiDungDonList != this.props.phanLoaiNguoiDungDonList) {
      this.state.phanLoaiNguoiDungDonList = nextProps.phanLoaiNguoiDungDonList;
      this.setState({...this.state});
    }
  }

  render() {
    return (
      <div className="box-items">
        <div className="box-forward">
          <div className="container-box">
            <div className="title">
              <div className="rows">
                <div className="col-12 mt15">
                  <h3>Thông tin người đứng đơn/vụ việc</h3>
                </div>
              </div>
            </div>
            <div className="group-box">
              <div className="items-form inline-bottom">
                <div className="rows">
                  <DropDown label="Phân loại người đứng đơn" require={true} options={this.state.phanLoaiNguoiDungDonList} keyName="giaTri" valueName="ten" selectedValue={this.state.loaiNguoiDungDonId} onChange={this.onChange.bind(this, 'loaiNguoiDungDonId')} placeholder={null} className="col-input" name="dropdownLoaiNguoiDungDonId"/>
                      <ShowIf condition={this.state.loaiNguoiDungDonId == 'CO_QUAN_TO_CHUC'}>
                        <div>
                          <Input className="col-input" label="Tên cơ quan/ Tổ chức" name="tenCoQuan" require={true} bindValidator={this} channel="formTaoDon" value={this.state.tenCoQuan} onChange={this.onChange.bind(this, 'tenCoQuan')} />
                          <Input className="col-input" label="Địa chỉ cơ quan" require={true} name="diaChiCoQuan" bindValidator={this} channel="formTaoDon" value={this.state.diaChiCoQuan} onChange={this.onChange.bind(this, 'diaChiCoQuan')} />
                          <Input className="col-input" type="sdt" label="Số điện thoại cơ quan" require={true} name="soDienThoaiCoQuan" bindValidator={this} channel="formTaoDon" value={this.state.soDienThoai} onChange={this.onChange.bind(this, 'soDienThoai')} />
                        </div>
                      </ShowIf>
                      <ShowIf condition={this.state.loaiNguoiDungDonId == 'DOAN_DONG_NGUOI'}>
                        <div>
                          <Input className="col-input" type="sdt" maxLength={2} label="Số người" require={true} bindValidator={this} channel="formTaoDon" value={this.state.soNguoi} onChange={this.onChange.bind(this, 'soNguoi')} name="soNguoi" />
                          <Input className="col-input" type="sdt" maxLength={2} name="soNguoiDaiDien" label="Số người đại diện" require={true} bindValidator={this} channel="formTaoDon" value={this.state.soNguoiDaiDien} onChange={this.onChange.bind(this, 'soNguoiDaiDien')} />
                        </div>
                      </ShowIf>
                    </div>
                </div>
              </div>
              {/*group-box*/}
              <div className="group-box">
                {
                  this.props.nguoiDaiDien.map((item,i) => {
                    let label = "";
                    if (this.props.nguoiDaiDien.length > 1) {
                      label = this.state.loaiNguoiDungDonId == 'CA_NHAN' ? `NGƯỜI ĐỨNG ĐƠN ${(i + 1)}` : `NGƯỜI ĐẠI DIỆN ${(i + 1)}`;
                    } else {
                      label = this.state.loaiNguoiDungDonId == 'CA_NHAN' ? "NGƯỜI ĐỨNG ĐƠN" : "NGƯỜI ĐẠI DIỆN";
                    }

                    return (
                      <ThongTinCaNhan
                        key={i}
                        index={i}
                        data={item}
                        label={label}
                        onChange={this.getThongTinCaNhan.bind(this, i)}
                        handleRemove={this.handleRemove.bind(this, item)}
                        isRemoveable={(this.props.nguoiDaiDien.length > 1)}
                        bindValidator={this}
                        isDonCu={this.props.isDonCu}
                      />
                    )
                  })
                }
                {
                  ((this.props.nguoiDaiDien.length < 4 && this.state.loaiNguoiDungDonId == 'CA_NHAN' ) ||
                    (this.props.nguoiDaiDien.length < 10 && this.state.loaiNguoiDungDonId == 'DOAN_DONG_NGUOI' )) ? (
                    <div className="items-form inline-bottom">
                      <div className="rows">
                        <div className="add-items-form">
                          <Link onClick={this.addNguoiDaiDien.bind(this)} title="">
                            {
                              this.state.loaiNguoiDungDonId != 'CA_NHAN' ? 'Thêm người đại diện' : 'Thêm người đứng đơn'
                            }
                          </Link>
                        </div>
                      </div>
                    </div>
                  ) : (<div className="items-form inline-bottom"></div>)
                }
                <ShowIf condition={this.state.loaiNguoiDungDonId == 'DOAN_DONG_NGUOI'}>
                  <ListGroupTypeReception onChange={this.onChangeDoanDongNguoi.bind(this)} data={this.props.editData} onRemove={this.props.onRemove}/>
                </ShowIf>
              </div>
              <div className="group-box">
                <CheckBox
                  ten="Có ủy quyền"
                  isChecked={this.state.flagUyQuyen}
                  onChange={this.onChangeCheckBox.bind(this, 'flagUyQuyen')}
                  componentFill={<ThongTinUyQuyen onChange={this.onChangeThongTinUyQuyen.bind(this)} isDonCu={this.props.isDonCu} onRemove={this.props.onRemove} data={this.props.editData} bindValidator={this} onSave={this.props.onSave}/>} />
              </div>
          </div>
        </div>
        {/*box-forward*/}
      </div>
    );
  }
}
ThongTinNguoiDungDon.defaultProps = {
  editData: {},
  onSave: false,
  phanLoaiNguoiDungDonList: []
}

function bindStateToProps(state) {
  return {
    phanLoaiNguoiDungDonList: state.duLieuHeThong.phanLoaiNguoiDungDonList,
    nguoiDaiDien: state.formDataTiepCongDan.nguoiDungDon,
    editData: state.formDataTiepCongDan.editData,
    showField: state.formDataTiepCongDan.showField
  };
}

export default connect(bindStateToProps)(validatable(ThongTinNguoiDungDon));



// WEBPACK FOOTER //
// ./src/components/modules/reception/add-reception/ThongTinNguoiDungDon.jsx